import {
  BillingMonthly,
  BillingPrePayment,
  BillingSubscription,
} from 'app/graphql/generated/admin/graphql';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function truncateText(text: string, maxLength: number) {
  if (text.length <= maxLength) {
    return text;
  }
  return `${text.slice(0, maxLength)}…`;
}

export function isLegacyBilling(
  billingPeriodSettings:
    | BillingPrePayment
    | BillingMonthly
    | BillingSubscription
    | null
    | undefined,
) {
  if (!billingPeriodSettings) {
    return true;
  }
  return (
    billingPeriodSettings?.__typename === 'BillingMonthly' ||
    billingPeriodSettings?.__typename === 'BillingPrePayment'
  );
}

// v2 (checkout-intents) developers are on subscription billing; legacy v1
// developers are on monthly / prepayment (or have no billing yet).
export function isV2Developer(
  billingPeriodSettings:
    | BillingPrePayment
    | BillingMonthly
    | BillingSubscription
    | null
    | undefined,
) {
  return !isLegacyBilling(billingPeriodSettings);
}
